"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledLabelContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const LabelStyle = _styledComponents.default.label`
  color: ${({
  theme
}) => theme.text.color};
  display: block;
  font-weight: 600;

  ${({
  isRequired,
  theme
}) => isRequired && (0, _styledComponents.css)`
      ::after {
        content: "*";
        color: ${theme.colors.asterisk};
        font-weight: 700;
        margin-left: ${theme.spacing}px;
      }
    `}

  ${({
  disabled,
  theme
}) => disabled && (0, _styledComponents.css)`
      color: ${theme.disabled.disabled};
    `}
`;
LabelStyle.defaultProps = {
  theme: _base.default
};
LabelStyle.propTypes = {
  disabled: _propTypes.default.bool
};
const StyledLabelContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  ${({
  align,
  inline,
  pr,
  pl,
  width,
  theme
}) => inline && (0, _styledComponents.css)`
      box-sizing: border-box;
      margin-bottom: 0;
      ${pr && (0, _styledComponents.css)`
        padding-right: ${pr * theme.spacing}px;
      `};
      ${pl && (0, _styledComponents.css)`
        padding-left: ${pl * theme.spacing}px;
      `};
      justify-content: ${align === "right" ? "flex-end" : "flex-start"};
      width: ${width === 0 ? StyledLabelContainer.defaultProps.width : width}%;
    `}

  ${({
  childOfForm,
  optional
}) => childOfForm && (0, _styledComponents.css)`
      ${optional && (0, _styledComponents.css)`
        ::after {
          content: "(optional)";
          font-weight: 350;
          margin-left: 4px;
        }
      `}
    `}
`;
exports.StyledLabelContainer = StyledLabelContainer;
StyledLabelContainer.defaultProps = {
  align: "right",
  theme: _base.default,
  width: 30
};
StyledLabelContainer.propTypes = {
  align: _propTypes.default.oneOf(["left", "right"]),
  inline: _propTypes.default.bool,
  width: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  pr: _propTypes.default.number,
  pl: _propTypes.default.number
};
var _default = LabelStyle;
exports.default = _default;